"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Util_1 = require("../Util");
/**
 * Interprets keys as predicates.
 * The most common case in JSON-LD processing.
 */


var EntryHandlerPredicate =
/*#__PURE__*/
function () {
  function EntryHandlerPredicate() {
    _classCallCheck(this, EntryHandlerPredicate);
  }

  _createClass(EntryHandlerPredicate, [{
    key: "isPropertyHandler",
    value: function isPropertyHandler() {
      return true;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, keys, depth, inProperty) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = keys[depth];

                if (!_context.t0) {
                  _context.next = 10;
                  break;
                }

                _context.t1 = util;
                _context.next = 5;
                return parsingContext.getContext(keys);

              case 5:
                _context.t2 = _context.sent;
                _context.t3 = keys[depth];
                _context.next = 9;
                return _context.t1.predicateToTerm.call(_context.t1, _context.t2, _context.t3);

              case 9:
                _context.t0 = !!_context.sent;

              case 10:
                return _context.abrupt("return", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function validate(_x, _x2, _x3, _x4, _x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parsingContext, util, key, keys, depth) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", keys[depth]);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function test(_x6, _x7, _x8, _x9, _x10) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(parsingContext, util, key, keys, value, depth, testResult) {
        var keyOriginal, parentKey, context, predicate, objectContext, object, reverse, listValueContainer, listPointer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                keyOriginal = keys[depth];
                _context3.next = 3;
                return util.unaliasKeywordParent(keys, depth);

              case 3:
                parentKey = _context3.sent;
                _context3.next = 6;
                return parsingContext.getContext(keys);

              case 6:
                context = _context3.sent;
                _context3.next = 9;
                return util.predicateToTerm(context, key);

              case 9:
                predicate = _context3.sent;

                if (!predicate) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 13;
                return parsingContext.getContext(keys, 0);

              case 13:
                objectContext = _context3.sent;
                _context3.next = 16;
                return util.valueToTerm(objectContext, key, value, depth, keys);

              case 16:
                object = _context3.sent;

                if (!object) {
                  _context3.next = 28;
                  break;
                }

                reverse = Util_1.Util.isPropertyReverse(context, keyOriginal, parentKey); // Special case if our term was defined as an @list, but does not occur in an array,
                // In that case we just emit it as an RDF list with a single element.

                listValueContainer = Util_1.Util.getContextValueContainer(context, key) === '@list';

                if (!(listValueContainer || value['@list'])) {
                  _context3.next = 24;
                  break;
                }

                if ((listValueContainer || value['@list'] && !Array.isArray(value['@list'])) && object !== util.rdfNil) {
                  listPointer = util.dataFactory.blankNode();
                  parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfRest, util.rdfNil, util.getDefaultGraph()));
                  parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfFirst, object, util.getDefaultGraph()));
                  object = listPointer;
                } // Lists are not allowed in @reverse'd properties


                if (!(reverse && !parsingContext.allowSubjectList)) {
                  _context3.next = 24;
                  break;
                }

                throw new Error("Found illegal list value in subject position at ".concat(key));

              case 24:
                _context3.next = 26;
                return EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, parentKey, predicate, object, reverse);

              case 26:
                _context3.next = 29;
                break;

              case 28:
                // An invalid value was encountered, so we ignore it higher in the stack.
                parsingContext.emittedStack[depth] = false;

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function handle(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }], [{
    key: "handlePredicateObject",

    /**
     * Handle the given predicate-object by either emitting it,
     * or by placing it in the appropriate stack for later emission when no @graph and/or @id has been defined.
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {Util} util A utility instance.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @param parentKey The parent key.
     * @param {Term} predicate The predicate.
     * @param {Term} object The object.
     * @param {boolean} reverse If the property is reversed.
     * @return {Promise<void>} A promise resolving when handling is done.
     */
    value: function () {
      var _handlePredicateObject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(parsingContext, util, keys, depth, parentKey, predicate, object, reverse) {
        var depthProperties, depthOffsetGraph, depthPropertiesGraph, subject, atGraph, graph;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                depthProperties = depth - (parentKey === '@reverse' ? 1 : 0);
                _context4.next = 3;
                return util.getDepthOffsetGraph(depth, keys);

              case 3:
                depthOffsetGraph = _context4.sent;
                depthPropertiesGraph = depth - depthOffsetGraph;

                if (parsingContext.idStack[depthProperties]) {
                  // Emit directly if the @id was already defined
                  subject = parsingContext.idStack[depthProperties]; // Check if we're in a @graph context

                  atGraph = depthOffsetGraph >= 0;

                  if (atGraph) {
                    graph = parsingContext.idStack[depthPropertiesGraph - 1];

                    if (graph) {
                      // Emit our quad if graph @id is known
                      if (reverse) {
                        util.validateReverseSubject(object);
                        parsingContext.emitQuad(depth, util.dataFactory.quad(object, predicate, subject, graph));
                      } else {
                        parsingContext.emitQuad(depth, util.dataFactory.quad(subject, predicate, object, graph));
                      }
                    } else {
                      // Buffer our triple if graph @id is not known yet.
                      if (reverse) {
                        util.validateReverseSubject(object);
                        parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                          subject: object,
                          predicate: predicate,
                          object: subject
                        });
                      } else {
                        parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                          subject: subject,
                          predicate: predicate,
                          object: object
                        });
                      }
                    }
                  } else {
                    // Emit if no @graph was applicable
                    if (reverse) {
                      util.validateReverseSubject(object);
                      parsingContext.emitQuad(depth, util.dataFactory.quad(object, predicate, subject, util.getDefaultGraph()));
                    } else {
                      parsingContext.emitQuad(depth, util.dataFactory.quad(subject, predicate, object, util.getDefaultGraph()));
                    }
                  }
                } else {
                  // Buffer until our @id becomes known, or we go up the stack
                  if (reverse) {
                    util.validateReverseSubject(object);
                  }

                  parsingContext.getUnidentifiedValueBufferSafe(depthProperties).push({
                    predicate: predicate,
                    object: object,
                    reverse: reverse
                  });
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function handlePredicateObject(_x18, _x19, _x20, _x21, _x22, _x23, _x24, _x25) {
        return _handlePredicateObject.apply(this, arguments);
      }

      return handlePredicateObject;
    }()
  }]);

  return EntryHandlerPredicate;
}();

exports.EntryHandlerPredicate = EntryHandlerPredicate;